<script setup>
const { isNewUser, organization } = storeToRefs(useUserStore())
// We are showing the onboarding modal only if the user is new and has an active organization
</script>

<template>
  <FreemiumOnboardingModalSteps v-if="isNewUser && organization" />
</template>
